<template>
    <div>
        <HeaderBar/>
        <div class="d-flex flex-column h-75 px-1">
        <div class="d-flex  justify-content-center serviceTitle mt-5">Servicios</div>
        <div class="d-flex flex-column align-items-center flex-fill justify-content-center  servicePosition">
            <b-link :to="{name:'basic-femaledatainsemination'}" class="w-100"><b-button class="bg-primary" block> Inseminación</b-button></b-link>
            <b-link :to="{name:'basic-femaledatanaturalriding'}" class="w-100 mt-1"><b-button class="bg-primary" block> Monta Natural</b-button></b-link>
        </div>
        <ControlMenu />
        </div>
    </div>
</template>


<script>
    import { BButton, BLink } from 'bootstrap-vue'
    import ControlMenu from '@/components/ControlMenu.vue'
    import HeaderBar from '@/components/HeaderBar.vue'

    export default {
        components: {
            BButton,
            ControlMenu,
            HeaderBar,
            BLink,
        }
    }
</script>

<style>
    .serviceTitle {
        font-weight: 600;
        font-size: 24px;
        color: #5E5873;
    }
    .servicePosition{
        margin-top:20%;
    }
    @media screen and (max-width: 600px) {
        .servicePosition{
            margin-top:70%;
        }
      }
</style>